
import React, { Fragment, useState } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch } from 'react-redux'

import { useProgrammation } from '../../../Hooks/UseProgrammation'
import useTranslation from '@/Hooks/UseTranslation'
import { updateTaskColorCode } from '../../../Services/ProgrammationManagerService'
import { updateTaskFieldAction } from '../../../Redux/Actions/ProgrammationManagerActions'

import ColorCodeManager from '../components/ColorCodeManager'

import PaletteIcon from '../../SvgImages/Palette'

const TaskColorCode = () => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { itemOpened, patchItemOpened } = useProgrammation()

  const [ show, setShow ] = useState(false)

  const handleSelectColorCode = async (colorCode?: any) => {

    const [ error ] = await updateTaskColorCode(itemOpened?._id, colorCode?._id || '')

    if (error) return console.log(error)

    patchItemOpened({
      colorCode: colorCode,
    })

    await dispatch(updateTaskFieldAction(itemOpened._id, 'colorCode', colorCode?._id || ''))

    setShow(false)
  }

  return (
    <Fragment>
      <Form.Group>
        <Form.Label>
          {t('PROGRAMMATION_MANAGER:ColorCodeLabel')}
        </Form.Label>
        <button
          type="button"
          className={`color-code-manager-toggle ${show ? 'active' : ''}`}
          onClick={() => setShow(true)}
        >
          {itemOpened.colorCode && (
            <Fragment>
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  columnGap: '0.5rem',
                }}
              >
                <div
                  className="color-thumb"
                  style={{ backgroundColor: itemOpened.colorCode.color }}
                />{' '}
                {itemOpened.colorCode.name}
              </div>
              <div className="separator"></div>
              <button
                className="action-button cursor-pointer"
                onClick={(e: any) => {
                  e.stopPropagation()
                  e.preventDefault()

                  handleSelectColorCode()
                }}
              >
                <i className="fas fa-fw fa-times"></i>
              </button>
            </Fragment>
          )}
          {!itemOpened.colorCode && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              columnGap: '0.5rem',
            }}>
              <PaletteIcon height={14} width={14} /> {t('PROGRAMMATION_MANAGER:ColorCodeSelect')}
            </div>
          )}
        </button>
      </Form.Group>

      <ColorCodeManager
        show={show}
        onHide={() => setShow(false)}
        onSelect={handleSelectColorCode}
      />
    </Fragment>
  )
}

export default TaskColorCode
